import i18n from 'modules/core/lib/i18n'

class FieldTranslations {
  employeeFields = [
    'bank_number',
    'first_name',
    'last_name',
    'gender',
    'identifier',
    'identifier_type',
    'nationality',
    'social_security_number',
    'acronym',
    'street_type',
    'street_name',
    'building_number',
    'stairwell',
    'floor',
    'gate',
    'city',
    'country',
    'workplace',
    'email',
    'phone_number',
    'birthday_on',
    'postal_code',
    'address',
    'starts_on',
    'ends_on',
  ]

  contractFields = [
    'contract_start_date',
    'agreement_code',
    'education_level_code',
    'classification_code',
    'cno_ocupation_code',
    'contribution_type_a3_id',
    'regime_a3_id',
    'occupation_code_tgss_code',
    'cotization_group_a3_id',
    'contract_type_code',
    'work_day_type_code',
    'working_hours_code',
    'working_hours_frequency_code',
  ]

  t(field: string): string {
    switch (field) {
      case 'bank_number':
        return i18n.t('bookkeepers.incidence.details.bank_number')
      case 'first_name':
        return i18n.t('bookkeepers.incidence.details.first_name')
      case 'last_name':
        return i18n.t('bookkeepers.incidence.details.last_name')
      case 'gender':
        return i18n.t('bookkeepers.incidence.details.gender')
      case 'identifier':
        return i18n.t('bookkeepers.incidence.details.identifier')
      case 'identifier_type':
        return i18n.t('bookkeepers.incidence.details.identifier_type')
      case 'nationality':
        return i18n.t('bookkeepers.incidence.details.nationality')
      case 'contract_start_date':
        return i18n.t('bookkeepers.incidence.details.contract_start_date')
      case 'social_security_number':
        return i18n.t('bookkeepers.incidence.details.social_security_number')
      case 'acronym':
        return i18n.t('bookkeepers.incidence.details.acronym')
      case 'street_type':
        return i18n.t('bookkeepers.incidence.details.street_type')
      case 'street_name':
        return i18n.t('bookkeepers.incidence.details.street_name')
      case 'building_number':
        return i18n.t('bookkeepers.incidence.details.building_number')
      case 'stairwell':
        return i18n.t('bookkeepers.incidence.details.stairwell')
      case 'floor':
        return i18n.t('bookkeepers.incidence.details.floor')
      case 'gate':
        return i18n.t('bookkeepers.incidence.details.gate')
      case 'city':
        return i18n.t('bookkeepers.incidence.details.city')
      case 'country':
        return i18n.t('bookkeepers.incidence.details.country')
      case 'workplace':
        return i18n.t('bookkeepers.incidence.details.workplace')
      case 'email':
        return i18n.t('bookkeepers.incidence.details.email')
      case 'phone_number':
        return i18n.t('payroll_integrations.incidences.a3innuva.unavailable_fields.phone_number')
      case 'birthday_on':
        return i18n.t('payroll_integrations.incidences.a3innuva.unavailable_fields.birthday_on')
      case 'postal_code':
        return i18n.t('payroll_integrations.incidences.a3innuva.unavailable_fields.postal_code')
      case 'company_code':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.configuration_unavailable_fields.settings.company'
        )
      case 'employee_code':
        return i18n.t('payroll_integrations.incidences.a3innuva.unavailable_fields.employee_code')
      case 'location_code':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.configuration_unavailable_fields.settings.work_center'
        )
      case 'leave_type':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.configuration_unavailable_fields.settings.leave_type'
        )
      case 'address':
        return i18n.t('payroll_integrations.incidences.a3innuva.unavailable_fields.address')
      case 'agreement_code':
        return i18n.t('payroll_integrations.incidences.a3innuva.unavailable_fields.agreement_type')
      case 'classification_code':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.unavailable_fields.classification_code'
        )
      case 'cno_ocupation_code':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.unavailable_fields.cno_ocupation_code'
        )
      case 'contribution_type_a3_id':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.unavailable_fields.contribution_type_a3_id'
        )
      case 'regime_a3_id':
        return i18n.t('payroll_integrations.incidences.a3innuva.unavailable_fields.regime_a3_id')
      case 'occupation_code_tgss_code':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.unavailable_fields.occupation_code_tgss_code'
        )
      case 'cotization_group_a3_id':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.unavailable_fields.cotization_group_a3_id'
        )
      case 'job_position_a3_code':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.configuration_unavailable_fields.settings.job_position'
        )
      case 'education_level_code':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.unavailable_fields.education_level_code'
        )
      case 'contract_type_code':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.unavailable_fields.contract_type_code'
        )
      case 'work_day_type_code':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.unavailable_fields.work_day_type_code'
        )
      case 'working_hours_code':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.unavailable_fields.working_hours_code'
        )
      case 'working_hours_frequency_code':
        return i18n.t(
          'payroll_integrations.incidences.a3innuva.unavailable_fields.working_hours_frequency_code'
        )
      case 'starts_on':
        return i18n.t('bookkeepers.incidence.details.starts_on')
      case 'ends_on':
        return i18n.t('bookkeepers.incidence.details.ends_on')
      case 'personal_email':
        return i18n.t('bookkeepers.incidence.details.personal_email')
      default:
        return field
    }
  }

  isEmployeeField(field: string): boolean {
    return this.employeeFields.includes(field)
  }

  isContractField(field: string): boolean {
    return this.contractFields.includes(field)
  }
}

export default new FieldTranslations()
